(() => {
  const slugify = (s) =>
    (s || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[\s]+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");

  const initOne = (root) => {
    if (!root || root.dataset.hdTocInited === "1") return;
    root.dataset.hdTocInited = "1";

    const btn = root.querySelector(".hd-toc__btn");
    const panel = root.querySelector(".hd-toc__panel");
    const list = root.querySelector(".hd-toc__list");
    const iconOpen = root.querySelector(".hd-toc__icon--open");
    const iconClose = root.querySelector(".hd-toc__icon--close");

    if (!btn || !panel || !list) return;

    const contentSelector = root.getAttribute("data-hd-toc-content") || ".article-template__content";
    const headingsSelector = root.getAttribute("data-hd-toc-headings") || "h2, h3, h4";

    const content = document.querySelector(contentSelector);
    if (!content) return;

    // Build list once
    const headers = content.querySelectorAll(headingsSelector);
    if (!headers.length) {
      // Không có headings => ẩn luôn nút cho sạch UI
      root.style.display = "none";
      return;
    }

    const seenIds = new Set();
    headers.forEach((h, idx) => {
      const level = parseInt(h.tagName.replace("H", ""), 10);

      let id = h.id && h.id.trim() ? h.id.trim() : slugify(h.textContent);
      if (!id) id = `section-${idx}`;

      // Ensure unique
      let finalId = id;
      let c = 1;
      while (seenIds.has(finalId) || document.getElementById(finalId)) {
        finalId = `${id}-${c++}`;
      }
      seenIds.add(finalId);
      h.id = finalId;

      const li = document.createElement("li");
      li.className = `toc-level-${level}`;
      li.innerHTML = `<a href="#${finalId}">${h.textContent}</a>`;
      list.appendChild(li);
    });

    const open = () => {
      panel.classList.remove("hidden");
      btn.setAttribute("aria-expanded", "true");
      if (iconOpen) iconOpen.style.display = "none";
      if (iconClose) iconClose.style.display = "inline";
    };

    const close = () => {
      panel.classList.add("hidden");
      btn.setAttribute("aria-expanded", "false");
      if (iconOpen) iconOpen.style.display = "inline";
      if (iconClose) iconClose.style.display = "none";
    };

    btn.addEventListener("click", () => {
      const isOpen = !panel.classList.contains("hidden");
      if (isOpen) close();
      else open();
    });
  };

  const init = () => {
    document.querySelectorAll("[data-hd-toc-root]").forEach(initOne);
  };

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:select", init);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
